import BaseConfiguratorService from '@configuratorware/configurator-frontendgui/App/Services/ConfiguratorService';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';

class ConfiguratorService extends BaseConfiguratorService {
  async createMediaDataForConfiguration(configuration) {
    try {
      Services.visualization.setDesignAreaScreenshotMode(true);
      const { designViews } = Services.store.state.designView;
      const defaultViewIdentifier = Services.designData.getInitialDesignViewIdentifier();
      const defaultDesignView = designViews.find(({ identifier }) => identifier === defaultViewIdentifier);
      Services.visualization.setDefaultDesignView(defaultDesignView);
      return await super.createMediaDataForConfiguration(configuration);
    } finally {
      Services.visualization.setDesignAreaScreenshotMode(false);
    }
  }
}

export default ConfiguratorService;
